<template>
  <v-tailwind-modal v-model="EditReport" @confirm="SaveReport" @cancel="cancel">
    <template v-slot:title>{{ $t('setreports.editreport') }}</template>
    <template v-slot:icon><!-- Edit - Fill: 1 Weight: 400 Grade: 0 Optical Size: 48 -->
      <svg class="text-skin-b-list-mute" fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
        <path d="M794 390 666 262l42-42q17-17 42.5-16.5T793 221l43 43q17 17 17 42t-17 42l-42 42Zm-42 42L248 936H120V808l504-504 128 128Z"/>
      </svg>
    </template>
    <div class="grid gap-4 sm:grid-cols-2">
      <div class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_type"
          :label="$t('setreports.type')"
          :placeholder="$t('setreports.type')"   
        >
        <template v-slot:options>
          <option value="statistic">{{$t('setreports.statistic')}}</option>
        </template>
      </SelectWithLabelIcon>
      </div>
      <div v-if="editmodal_type=='statistic'" class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_filter"
          label="Report für"
          placeholder="RFID auswählen"
          @update:modelValue="fillemail"
        >
          <template #options>
            <option value="-1">{{ $t('pairing.filterallrfid') }}</option>

            <option
              v-for="(user, index) in userlist"
              :key="'u-' + index"
              :value="'##USERID##'+user.userId"
            >
              {{ user.alias + ' - ' + user.name }}
            </option>

            <option
              v-for="(rfid, index) in rfidlist"
              :key="'r-' + index"
              :value="rfid.token"
            >
              {{ rfid.info + ' (' + rfid.token + ')' }}
            </option>
          </template>
        </SelectWithLabelIcon>
      </div>
      <div v-else class="form-group mb-2 hidden sm:block">
      </div>

      <div class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_frequency"
          @update:modelValue="editmodal_execution=1"
          :label="$t('setreports.interval')"
          :placeholder="$t('setreports.interval')"   
        >
        <template v-slot:options>
          <option value="dayly">{{$t('common.dayly')}}</option>
          <option value="weekly">{{$t('common.weekly')}}</option>
          <option value="monthly">{{$t('common.monthly')}}</option>
          <option value="quarterly">{{$t('common.quarterly')}}</option>
          <option value="yearly">{{$t('common.yearly')}}</option>
        </template>
        </SelectWithLabelIcon>
      </div>

      <div v-if="editmodal_frequency=='dayly'" class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_execution"
          :label="$t('setreports.everyhour')"
          :placeholder="$t('setreports.everyhour')"   
        >
        <template v-slot:options>
          <option v-for="index in 24" :key="index - 1" :value="index - 1">
            {{ $t('common.time', { time: (index - 1).toString().padStart(2, '0') + ':00' }) }}
          </option>
        </template>
        </SelectWithLabelIcon>
      </div>
      <div v-if="editmodal_frequency=='weekly'" class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_execution"
          :label="$t('setreports.everyday')"
          :placeholder="$t('setreports.everyday')"   
        >
        <template v-slot:options>
          <option value="1">{{$t('common.monday')}}</option>
          <option value="2">{{$t('common.tuesday')}}</option>
          <option value="3">{{$t('common.wednesday')}}</option>
          <option value="4">{{$t('common.thursday')}}</option>
          <option value="5">{{$t('common.friday')}}</option>
          <option value="6">{{$t('common.saturday')}}</option>
          <option value="7">{{$t('common.sunday')}}</option>
        </template>
        </SelectWithLabelIcon>
      </div>
      <div v-if="editmodal_frequency=='monthly'" class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_execution"
          :label="$t('setreports.everymonth')"
          :placeholder="$t('setreports.everymonth')"   
        >
        <template v-slot:options>
          <option v-for="index in 28" :key="index" :value="index">
            {{ $t('setreports.monthly', { date: index.toString().padStart(2, '0') }) }}
          </option>
        </template>
        </SelectWithLabelIcon>
      </div>
      <div v-if="editmodal_frequency=='quarterly'" class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_execution"
          :label="$t('setreports.everyquarter')"
          :placeholder="$t('setreports.everyquarter')"   
        >
        <template v-slot:options>
          <option value="1">{{ $t('setreports.quarterly', { date: editmodal_execution.toString().padStart(2, '0') }) }}</option>
        </template>
        </SelectWithLabelIcon>
      </div>
      <div v-if="editmodal_frequency=='yearly'" class="form-group mb-2">
        <SelectWithLabelIcon
          v-model="editmodal_execution"
          :label="$t('setreports.everyyear')"
          :placeholder="$t('setreports.everyyear')"   
        >
        <template v-slot:options>
          <option value="1">{{ $t('setreports.yearly', { date: editmodal_execution.toString().padStart(2, '0') }) }}</option>
        </template>
        </SelectWithLabelIcon>
      </div>


      <div class="form-group mb-2 sm:col-span-2">
        <TextareaLabelError
          v-model="editmodal_recipient"
          :label="$t('setreports.recipients')"
          :placeholder="$t('setreports.recipientph')"
          @valid="editmodal_recipient_valid = $event"
        />
      </div>
    </div>

  </v-tailwind-modal>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />

  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('settings.service')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconMail             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody v-if="logbox">
      <template v-slot:formgrid>

          <div class="">
            <div>
              <InputLabelError 
                v-model="user"
                :label="$t('setreports.emailuser')"
                :placeholder="$t('setreports.emailuser')"
                validationType="filled"
                :validator_off="!pushon"
                @valid="(status) => valid_user = status"
                @update:modelValue ="onChange"
              />
            </div>
            <div>
              <InputLabelError 
                v-model="pass"
                :label="$t('setreports.emailpass')"
                :placeholder="passph"
                validationType="filled"
                :validator_off="!pushon"
                @valid="(status) => valid_pass = status"
                @update:modelValue ="onChange"
              />
            </div>
          </div>

          <div class="">
            <div>
              <InputLabelError 
                v-model="host"
                :label="$t('setreports.emailhost')"
                :placeholder="$t('setreports.emailhostph')"
                validationType="filled"
                :validator_off="!pushon"
                @valid="(status) => valid_host = status"
                @update:modelValue ="onChange"
            />
            </div>
            <div>
              <InputLabelError 
                v-model="port"
                :label="$t('setreports.emailport')"
                :placeholder="$t('setreports.emailport')"
                validationType="number"
                :validator_off="!pushon"
                @valid="(status) => valid_port = status"
                @update:modelValue ="onChange"
              />
            </div>
            <div>
              <ToggleWithLabel 
                v-model="starttls"
                @update:model-value="SetPortDefault()"
                :label="$t('setreports.emailstarttls')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"
              />
            </div>

          </div>

          <div class="">
            <div>
                <InputLabelError 
                  v-model="sender"
                  :label="$t('setreports.emailadress')"
                  :placeholder="$t('setreports.emailadress')"
                  validationType="email"
                  :validator_off="!pushon"
                  @valid="(status) => valid_sender = status"
                  @update:modelValue ="onChange"
                />
            </div>
          </div>
          <div class="mt-7 text-right">
              <ActionButton 
                v-if="pushservice"
                :disabled="!allvalid||isDirty"
                :wfull="false"
                @click="testmailModal=true">
                {{$t('setreports.sendtestmail')}}
              </ActionButton>
          </div>
          <div class="w-full mt-4 sm:col-span-2">
            <ActionButton 
              :disabled="!allvalid || isDirty==false"
              @click="SaveService()">
              {{ $t('common.save') }}
            </ActionButton>
          </div>
          
          <div class="form-group mb-2 sm:col-span-2">
          <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setreports.configuredreports') }}</div>           
          </div>

          <div class="form-group mb-6 sm:col-span-2 overflow-x-scroll no-scrollbar">
            <table class="table-auto w-full p-2">
              <thead>
                <tr class="text-left">
                  <th class="pr-2">{{ $t('setreports.type') }}</th>
                  <th class="px-2">{{ $t('setreports.interval') }}</th>
                  <th class="px-2">{{ $t('setreports.recipient') }}</th>
                  <th class="px-2">{{ $t('setreports.lastexec') }}</th>
                  <th class="px-2">{{ $t('setreports.nextexec') }}</th>
                  <th class="pl-2 text-right">{{ $t('common.edit') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b border-skin-b-list-bord" v-for="(report, index) in mailreports" :key="index">
                  <td class="py-2">
                      {{ $t(`setreports.${report.typ}`) }}
                      <template v-if="report.typ=='statistic'&&report.filter!='-1'">
                        <br>({{ rfidInfo(report.filter) }})
                      </template>
                  </td>
                  <td class="p-2">{{ $t(`common.${report.frequency}`) }}</td>
                  <td class="px-2"> {{ report.recipient.length > 30 ? report.recipient.substring(0, 30) + '...' : report.recipient }}</td>
                  <td class="p-2">{{ report.lastExecution ? this.$dayjs(report.lastExecution).format('DD.MM.YYYY') : '' }}</td>
                  <td class="p-2">{{ this.$dayjs(report.nextExecution).format('DD.MM.YYYY') }}</td>
                  <td class="py-2 text-right">
                    <button @click="DeleteReport(report.id)"
                          type="button" class="inline-flex items-center px-2 py-1 text-sm font-medium 
                          text-skin-b-list-base bg-skin-b-list-back border-l-2 border-y-2 border-skin-b-list-bord rounded-l-md
                          hover:text-red-800 hover:bg-red-100  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="w-5 h-5 fill-current" fill="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                              <path d="m376-300 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 180q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520Zm-400 0v520-520Z"/>
                          </svg>                          
                          </button>
                          <button type="button" 
                          @click="editmodal_id = report.id;
                                  editmodal_type = report.typ;
                                  editmodal_frequency = report.frequency;
                                  editmodal_recipient = report.recipient;
                                  editmodal_execution = report.execution;
                                  editmodal_filter = report.filter;
                                  EditReport = true;" 
                          class="inline-flex items-center px-2 py-1 text-sm font-medium rounded-r-md
                          text-skin-b-list-base bg-skin-b-list-back border-2 border-skin-b-list-bord 
                          hover:text-skin-b-base hover:bg-skin-b-back  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="w-5 h-5 fill-current" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="m16.188 7.542-3.73-3.73 1.021-1.02q.521-.521 1.24-.521t1.239.521l1.25 1.25q.5.5.5 1.239 0 .74-.5 1.24Zm-1.23 1.229L6.229 17.5H2.5v-3.729l8.729-8.729Z"/>
                          </svg>
                          </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

      </template>
      <template v-slot:formbottom>

          <div class="w-full mt-6">
            <ActionButton 
              @click="editmodal_id = -1;
                      editmodal_type = 'statistic';
                      editmodal_frequency = 'monthly';
                      editmodal_recipient = '';
                      editmodal_execution = 1;
                      editmodal_filter = '-1';
                      EditReport = true;">
              {{ $t('setreports.createnewreport') }}
            </ActionButton>
          </div>

        </template>
    </SettingsBody>
    <SettingsBody v-else>
      <template v-slot:formgrid>
        <div class="w-full mt-4 sm:col-span-2">
          <TextfieldWithLabel
              :text="$t('setreports.onlylogbox',{box: this.$store.state.WbName })"
            />  
          </div>
      </template>
    </SettingsBody>
    <MultiModal
        :show="testmailModal"
        @close="testmailModal=false"
    >
        <template #header>
          {{$t('setreports.sendtestmail')}}
        </template>
          <div>
              <InputLabelError 
                v-model="testmail"
                :label="$t('setreports.testmail')"
                :placeholder="$t('setreports.testmailph')"
                validationType="email"
                @valid="(status) => valid_testmail = status"
              />
          </div>
        <template #footer>
            <ActionButton @click="testmailModal=false">
              {{ $t('common.cancel') }}
            </ActionButton>
            <ActionButton 
              @click="SendTestMail(testmail)"
              :disabled="!valid_testmail"
            >
              {{ $t('common.send') }}
            </ActionButton>            
        </template>
      </MultiModal>

  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconMail from './icons/IconMail.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import MultiModal from './elements/MultiModal.vue'
import ActionButton from './elements/ActionButton.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import TextareaLabelError from './elements/TextareaLabelError.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import InputLabelError from './elements/InputLabelError.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },  
  components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconMail,
      SettingsHeader, SettingsBody, MultiModal, ActionButton, SelectWithLabelIcon, TextareaLabelError, TextfieldWithLabel, InputLabelError, ToggleWithLabel, ConfirmLeaveModal
    }, 
  data() {
    return {
          isLoading: false,
          saveto: this.$store.state.WbId,
          pushservice: false,
          mailsettings: {},
          mailreports: {},
          rfidlist: {},
          userlist: {},
          sender: '',
          valid_sender: false,
          host: '',
          valid_host: false,
          port: '',
          valid_port: false,      
          user: '',
          valid_user: false,
          starttls: false,
          pass: '',
          passph: '',
          valid_pass: false,
          testmail: '',
          valid_testmail: false,
          testmailModal: false,
          EditReport: false,
          editmodal_id: -1,
          editmodal_type: 'statistic',
          editmodal_filter: '-1',
          editmodal_frequency: '',
          editmodal_execution: 1,          
          editmodal_recipient: '',
          editmodal_recipient_valid: false,
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false
    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
    pushon(){
      if(this.user==''||this.host==''||this.port==''||this.sender=='')
        return false;
      else
        return true;
    },
    allvalid(){
      if(this.pushon&&this.valid_user&&this.valid_pass&&this.valid_host&&this.valid_port&&this.valid_sender)
        return true;
      else
        return false;
    },
    logbox() {
      if(this.$store.state.WbId==this.$store.state.WbLogId)
        return true;
      else
        return false;
    },
    rfidInfo() {
      return (filter) => {
        if (!filter || filter === '-1') return ''

        // USER
        if (filter.startsWith('##USERID##')) {
          const userId = filter.slice('##USERID##'.length)
          const user = this.userlist.find(
            u => String(u.userId) === String(userId)
          )
          return user?.name || ''
        }

        // RFID
        const rfid = this.rfidlist.find(
          item => String(item.token) === String(filter)
        )
        return rfid?.info || ''
      }
    },
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    SetPortDefault() {
      this.port = '587';
    },
    fillemail(value) {
      // value ist der neue modelValue
      if (!value?.startsWith('##USERID##')) return

      const userId = value.slice('##USERID##'.length)
      const user = this.userlist.find(u => String(u.userId) === String(userId))
      if (user?.email) {
        this.editmodal_recipient = user.email
      } else {
        this.editmodal_recipient = ''
      }
    },
    SaveService() {  
      const API_URL = 'wallbox/settings.php';
        const userToken = this.$store.state.token;
        const params = {
          action: 'sync_mail_settings',
          user: userToken,
          mail_user: this.user,
          pass: this.pass=='****' ? '-1' : this.pass,
          host: this.host,
          port: this.port,
          sender: this.sender,
          starttls: this.starttls==true ? '1' : '0',
        };

        this.axios.get(API_URL, { params })
          .then(response => {
            if(response?.data?.status === 'token')
              this.$router.push({path: '/'}); 
            else if (response?.data?.status === 'ok') {
              console.log('Save SMTP successful.');
            } else {
              console.error('Error: Save SMTP failed.');
            }
          })
          .catch(error => {
            console.error('API Error:', error);
          })
          .finally(() => {
            this.fetchdata();
          });

      this.isDirty=false;          
    },
    SendTestMail(testmail) {
      const API_URL = 'wallbox/settings.php';
        const userToken = this.$store.state.token;
        const params = {
          action: 'test_mail',
          user: userToken,
          recipient: testmail,
        };

        this.axios.get(API_URL, { params })
          .then(response => {
              console.log('Send Testmail successful.');
              this.mailreports = response.data.tbl_report;
          })
          .catch(error => {
            console.error('API Error:', error);
          })
          .finally(() => {
            this.testmailModal=false;
            this.fetchdata();
          });
    },
    cleanEmails() {
      this.editmodal_recipient = this.editmodal_recipient
        .toLowerCase()
        .replace(/[^a-z0-9@._;-]/g, '')
    },
    SaveReport() {

      if(!this.editmodal_recipient_valid)
        return;

      this.cleanEmails();

      const API_URL = 'wallbox/settings.php';
        const userToken = this.$store.state.token;
        const params = {
          action: 'sync_report',
          user: userToken,
          report: this.editmodal_id,
          frequency: this.editmodal_frequency,
          recipient: this.editmodal_recipient,
          execution: this.editmodal_execution,
          filter: this.editmodal_filter,
        };

        this.axios.get(API_URL, { params })
          .then(response => {
            if(response?.data?.status === 'token')
              this.$router.push({path: '/'}); 
            else if (response?.data?.status === 'ok') {
              console.log('Edit report successful.');
              this.mailreports = response.data.tbl_report;
            } else {
              console.error('Error: Edit report failed.');
            }
          })
          .catch(error => {
            console.error('API Error:', error);
          })
          .finally(() => {
            this.EditReport=false;
            this.fetchdata();
          });
    },
    DeleteReport(ReportId){
      const API_URL = 'wallbox/settings.php';
        const userToken = this.$store.state.token;
        const params = {
          action: 'delete_report',
          user: userToken,
          report: ReportId,
        };

        this.axios.get(API_URL, { params })
          .then(response => {
            if(response?.data?.status === 'token')
              this.$router.push({path: '/'}); 
            else if (response?.data?.status === 'ok') {
              console.log('Delete report successful.');
              this.mailreports = response.data.tbl_report;
            } else {
              console.error('Error: Delete report failed.');
            }
          })
          .catch(error => {
            console.error('API Error:', error);
          })
          .finally(() => {
            this.fetchdata();
          });
    },
    cancel(close) {
      // some code...
      close()
    },
    convertToLocal(dateTimeString) {
        // Falls der Eingabestring leer ist, direkt zurückgeben
        if (!dateTimeString) return "";

        try {
            // Erstellen eines UTC-Datumsobjekts
            let utcDate = new Date(dateTimeString.replace(" ", "T") + "Z");

            // Falls das Datum ungültig ist, leeren String zurückgeben
            if (isNaN(utcDate.getTime())) return "";

            // Datum in lokaler Zeit formatieren
            let year = utcDate.getFullYear();
            let month = String(utcDate.getMonth() + 1).padStart(2, "0"); // Monat ist 0-basiert
            let day = String(utcDate.getDate()).padStart(2, "0");
            let hours = String(utcDate.getHours()).padStart(2, "0");
            let minutes = String(utcDate.getMinutes()).padStart(2, "0");
            let seconds = String(utcDate.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        } catch (error) {
            return ""; // Fehlerfall absichern
        }
    },
    async fetchdata() {
      this.isLoading = true;

      try {
        const token = this.$store.state.token;

        const urls = {
          mail_settings: `wallbox/info.php?action=get_mail_settings&user=${token}`,
          mail_reports:  `wallbox/info.php?action=get_reports&user=${token}`,
          rfid_list:     `wallbox/pairing.php?action=list_pairings&typ=charging_token&user=${token}`,
          user_list:     `wallbox/user.php?action=user_reload&user=${token}`,
        };

        const [mailSettingsRes, mailReportsRes, rfidListRes, userListRes] =
          await Promise.all([
            this.axios.get(urls.mail_settings),
            this.axios.get(urls.mail_reports),
            this.axios.get(urls.rfid_list),
            this.axios.get(urls.user_list),
          ]);

        // zentraler Token-Check (wenn irgendein Call "token" meldet)
        const responses = [
          { name: "mail settings", res: mailSettingsRes },
          { name: "mail reports",  res: mailReportsRes },
          { name: "rfid list",     res: rfidListRes },
          { name: "user list",     res: userListRes },
        ];

        if (responses.some(x => x.res?.data?.status === "token")) {
          this.$router.push({ path: "/" });
          return;
        }

        // 1) Mail Settings
        if (mailSettingsRes?.data?.status === "ok") {
          const s = mailSettingsRes.data.tbl_mailsettings ?? {};

          this.mailsettings = s;

          this.user = s.user ?? "";
          this.host = s.host ?? "";
          this.port = s.port ?? "";

          const starttlsValue = s.starttls ?? 0;
          this.starttls = starttlsValue === 1 || starttlsValue === true;

          this.sender = s.sender ?? "";

          const hasSmtp = !!(this.user && this.host && this.port);
          this.pushservice = hasSmtp;

          if (hasSmtp) {
            this.pass = "****";
            this.passph = this.$t("setreports.emailpassph");
          } else {
            this.passph = this.$t("setreports.emailpass");
          }
        } else {
          console.log("Error get mail settings");
        }

        // Reports
        if (mailReportsRes?.data?.status === "ok") {
          let reports = mailReportsRes.data.tbl_report ?? [];

          // Backend-Fallback: Objekt → Array
          if (!Array.isArray(reports)) {
            reports = Object.values(reports);
          }

          this.mailreports = reports.map(report => ({
            ...report,
            filter: report?.filter ?? "-1",
            nextExecution: this.convertToLocal(report?.nextExecution),
            lastExecution: this.convertToLocal(report?.lastExecution),
          }));
        } else {
          console.log("Error get reports");
        }

        // 3) RFID List
        if (rfidListRes?.data?.status === "ok") {
          const tbl = rfidListRes.data.tbl_remote_pairing ?? [];

          const dedupByToken = tbl.reduce((acc, obj) => {
            const key = obj?.token;
            if (!key) return acc;

            if (!acc[key]) {
              acc[key] = { ...obj, info: this.decodeHtml(obj?.info ?? "") };
            }
            return acc;
          }, {});

          this.rfidlist = Object.values(dedupByToken);
          this.rfidlist.sort((a, b) =>
            (a.info ?? "").localeCompare((b.info ?? ""), "de", { sensitivity: "base" })
          );
        } else {
          console.log("Error get rfid list");
        }

        // 4) User List
        // if (userListRes?.data?.status === "ok") {
        //   const tbl = userListRes.data.tbl_user ?? [];

        //     const dedupByUserId = tbl.reduce((acc, obj) => {
        //     const key = obj?.userId;
        //     if (key === undefined || key === null) return acc;

        //     if (!acc[key]) {
        //       acc[key] = {
        //         ...obj,
        //         alias: this.decodeHtml(obj?.alias ?? ""),
        //         name: this.decodeHtml(obj?.name ?? ""),
        //       };
        //     }
        //     return acc;
        //   }, {});

        //   this.userlist = Object.values(dedupByUserId);
        //   this.userlist.sort((a, b) =>
        //     (a.name ?? "").localeCompare((b.name ?? ""), "de", { sensitivity: "base" })
        //   );
        // } else {
        //   console.log("Error get user list");
        // }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },

  },
  created() {  
    this.fetchdata();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
